module.exports = __webpack_public_path__ + "media/images/div_lens/relatable-img1-4e9a4e99e6ebe0b9348fd7484d4487b2.png";